import ActivateDeactivateButton from "@app/components/activate-deactivate-button.tsx";
import ActivateDeactivateIndicator from "@app/components/activate-deactivate-indicator.tsx";
import { WorkLocationModel } from "@app/data/engine.ts";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    onEdit: (id: number) => void;
    onActivateDeactivate: (id: number, isActive: boolean) => void;
    rowCount: number;
}

const columnHelper = createColumnHelper<WorkLocationModel>();
export const assignmentWorkLocationsTableDefinition = ({ onEdit, onActivateDeactivate, rowCount }: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <IconButton tooltip={"Edit"} onClick={() => onEdit(item.row.original.locationId!)}>
                <EditIcon />
            </IconButton>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.city, { id: "city", header: "City" }),
    columnHelper.accessor((x) => x.stateName, { id: "stateName", header: "State" }),
    columnHelper.accessor((x) => x.active, {
        id: "active",
        header: () => (
            <Box display={"flex"} alignItems={"center"} gap={2}>
                Active
                <ActivateDeactivateIndicator />
            </Box>
        ),
        cell: (item) => (
            <ActivateDeactivateButton
                isActive={item.getValue() ?? false}
                onClick={() => onActivateDeactivate(item.row.original.locationId!, !item.getValue())}
            />
        ),
    }),
];
